var images = {
    chaselistLogo: require("../assets/images/mydock-logo.jpg").default,
    user: require("../assets/images/user-image.png").default,
    userBlue: require("../assets/images/user-fill-icon-blue.png").default,
    cityBackground: require("../assets/images/bg-images/bg-1.png").default,
    userMedium: require("../assets/images/user-square.png").default,
    background: require("../assets/images/mydockinfo/background.jpg").default,
    logoAnchor: require("../assets/images/mydockinfo/logo.svg").default,
    logoCircular: require("../assets/images/mydockinfo/logocircular.png").default,
    circularArrow: require("../assets/images/mydockinfo/circulararrow.png").default,
    onboardingbg: require("../assets/images/mydockinfo/onboardingbg.png").default,
    getstartedbg: require("../assets/images/mydockinfo/getstartedbg.png").default,
    registerBg: require("../assets/images/mydockinfo/registerbg.png").default,
    whiteborderlogo: require("../assets/images/mydockinfo/whiteborderlogo.png").default,
    loginBg: require("../assets/images/mydockinfo/loginbg.png").default,
    closeIcon: require("../assets/images/mydockinfo/closeIcon.png").default,
    brandHeaderCropped: require("../assets/images/mydockinfo/brandHeaderCropped.png").default,
    mouseIcon: require("../assets/images/mydockinfo/mouseIcon.png").default,
    greenarrowrightIcon: require("../assets/images/mydockinfo/greenarrowrightIcon.png").default,
};
/**
 * Preload all image assets to improve first paint.
 * Instantiating a new Image() triggers a browser fetch and stores
 * the asset in the browser's memory cache.
 */
var preloadImageAssets = function () {
    try {
        var urls = Object.values(images).filter(function (u) { return typeof u === 'string' && !!u; });
        // console.log("Preloading images:", urls);
        urls.forEach(function (href) {
            var img = new Image();
            img.src = href;
        });
    }
    catch (err) {
        console.error("Failed to preload images:", err);
    }
};
// Execute preloading
preloadImageAssets();
export default images;
